// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__nG08a","rotate":"Spinner_rotate__2I6Ls","path":"Spinner_path__4fkH_","dash":"Spinner_dash__2YmZ5"};